import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { get, post } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useEventDrawer } from "@/components/EventDrawer";

const FIELDS = [["title", "Titre *"], ["start_date", "Date début *", "date"], ["start_time", "Heure début", "time"], ["end_date", "Date fin", "date"], ["end_time", "Heure fin", "time"], ["venue_name", "Lieu"], ["address", "Adresse"], ["organizer_name", "Organisateur"], ["price_text", "Tarif (ex. gratuit, 10 €)"], ["url", "URL officielle"]];

export const ManualEventDialog = ({ open, onOpenChange }) => {
  const qc = useQueryClient();
  const { open: openEvent } = useEventDrawer();
  const { data: communes } = useQuery({ queryKey: ["communes-mon"], queryFn: () => get("/communes", { monitored: true }) });
  const [form, setForm] = useState({});
  const submit = async () => {
    if (!form.title || !form.start_date || !form.insee) return toast.error("Titre, date et commune obligatoires");
    const body = Object.fromEntries(Object.entries(form).filter(([, v]) => v));
    const r = await post("/events", body);
    toast.success(r.merged_into_existing ? "Doublon détecté : informations fusionnées dans l'événement existant" : "Événement ajouté (saisie manuelle)");
    qc.invalidateQueries({ queryKey: ["events"] });
    onOpenChange(false);
    setForm({});
    openEvent(r.id);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="manual-event-dialog">
        <DialogHeader><DialogTitle className="font-display">Ajouter un événement manuellement</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {FIELDS.map(([k, l, t]) => (
            <label key={k} className={`text-[11px] text-slate-500 ${["title", "address", "url"].includes(k) ? "col-span-2" : ""}`}>{l}
              <Input data-testid={`manual-${k}`} type={t || "text"} className="h-8 text-xs mt-0.5" value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
            </label>
          ))}
          <label className="text-[11px] text-slate-500 col-span-2">Commune *
            <select data-testid="manual-insee" className="w-full h-8 border border-slate-200 dark:border-slate-700 rounded-[3px] bg-transparent text-xs mt-0.5" value={form.insee || ""} onChange={(e) => setForm({ ...form, insee: e.target.value })}>
              <option value="">—</option>
              {(communes || []).map((c) => <option key={c.insee} value={c.insee}>{c.name} ({c.insee})</option>)}
            </select>
          </label>
        </div>
        <Button data-testid="manual-submit" onClick={submit}>Créer l'événement</Button>
      </DialogContent>
    </Dialog>
  );
};
